module.exports = __webpack_public_path__ + "img/edit_attached_files.0a26720f.svg";